import React, { Fragment, memo, useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { Breadcrumbs, Btn, H6, H4 } from "../../../../AbstractElements";
import AmenitiesModal from "./AmenitiesModal";
import MySearchInput from "../../../../mycomponents/MySearchInput";
import { useDispatch, useSelector } from "react-redux";
import { fetchAmenities, removeAmenities } from "./api";
import { amenitiesSelector } from "./amenitiesSlice";
import { toast } from "react-toastify";
import Loader from "../../../../Layout/Loader";
import BarLoader from "../../../../Layout/Loader/BarLoader";

const Amenities = () => {
  const dispatch = useDispatch();
  const { amenitiesData, isLoading, status } = useSelector(amenitiesSelector);
  console.log("isLoading:", isLoading);
  console.log("status:", status);
  console.log("amenitiesData:", amenitiesData);

  const [searchText, setSearchText] = useState("");
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(false);

  useEffect(() => {
    dispatch(fetchAmenities());
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("searchText:", searchText);
  };

  const handleAdd = () => setIsAdd(!isAdd);
  const handleEdit = (data) => {
    setIsEdit(!isEdit);
    setEditData(data);
  };

  const functionCB = (data) => {
    if (data.success == true) {
      return toast.success(data.result?.message || "Data successfully deleted");
    } else {
      return toast.error(
        data.result?.message || "Oops.. Something went wrong Please try again"
      );
    }
  };

  const handleDelete = (id) => {
    console.log("delete id", id);

    let conf = window.confirm("Are you sure you want to delete this amenity?");

    if (conf) {
      dispatch(removeAmenities({ id, CB: functionCB }));
    }
  };

  const AmenitiesRow = amenitiesData?.result?.data
    ?.filter((val, i) => {
      return (
        val.name.includes(searchText) ||
        val.code.includes(searchText) ||
        val.name.toLowerCase().includes(searchText.toLowerCase()) ||
        val.code.toLowerCase().includes(searchText.toLowerCase()) ||
        val.category.toLowerCase().includes(searchText.toLowerCase())
      );
    })
    .map((val, i) => {
      return {
        index: i + 1,
        name: val.name,
        code: val.code,
        category: val.category,
        action: (
          <Container className="d-flex btn-showcase">
            <Btn
              attrBtn={{
                color: "primary",
                outline: true,
                onClick: () => handleEdit(val),
              }}
            >
              {"Edit"}
            </Btn>
            <Btn
              attrBtn={{
                color: "danger",
                outline: true,
                onClick: () => handleDelete(val._id),
              }}
            >
              {"Delete"}
            </Btn>
          </Container>
        ),
      };
    });

  const AmenitiesColumns = [
    {
      name: <H6>#</H6>,
      selector: (row) => row.index,
      sortable: true,
      center: true,
      wrap: true,
      width: "77px",
    },
    {
      name: <H6>Name</H6>,
      selector: (row) => row.name,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: <H6>Code</H6>,
      selector: (row) => row.code,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: <H6>Category</H6>,
      selector: (row) => row.category,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: <H6>Action</H6>,
      selector: (row) => row.action,
      center: true,
      wrap: true,
    },
  ];

  const paginationOptions = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  };

  return (
    <Fragment>
      <AmenitiesModal
        isOpen={isAdd}
        ModalTitle={"Add Amenities Data"}
        toggler={handleAdd}
      />
      {isEdit && editData ? (
        <AmenitiesModal
          isOpen={isEdit}
          ModalTitle={"Edit Amenities Data"}
          toggler={handleEdit}
          editData={editData}
        />
      ) : null}

      <Container fluid={true}>
        <div className="d-flex">
          <Breadcrumbs
            parent="Amenities Configuration"
            title="Amenities Configuration"
          />

          <div className="social-tab">
            <MySearchInput
              handleSearch={handleSearch}
              searchText={searchText}
              setSearchText={setSearchText}
            />

            <Btn
              attrBtn={{
                className: "m-r-15 m-l-15 d-block",
                color: "success",
                // outline: true,
                onClick: handleAdd,
              }}
            >
              Add Amenities
            </Btn>
          </div>
        </div>

        <Row>
          <Col sm="12">
            <Card>
              <Col sm="12 box-col-12">
                <div className="social-tab">
                  <H4>AMENITIES DATA</H4>
                </div>
              </Col>

              <CardBody className="p-t-0">
                <div className="order-history table-responsive">
                  <DataTable
                    data={AmenitiesRow}
                    columns={AmenitiesColumns}
                    responsive={true}
                    pagination
                    paginationComponentOptions={paginationOptions}
                    subHeaderAlign="center"
                    progressPending={isLoading}
                    progressComponent={<BarLoader />}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default memo(Amenities);
